import { ReactNode } from 'react';
import { SystemProps } from '@storyofams/react-ui';

import { Container } from '~components';

type DynamicSectionContainerProps = {
  children: ReactNode;
  space?: any;
} & SystemProps;

export const DynamicSectionContainer = ({
  children,
  ...props
}: DynamicSectionContainerProps) => (
  <Container pt={0} pb={0} as="section" {...props}>
    {children}
  </Container>
);
